export default "__VITE_ASSET__ZibzP9NR__"